import React from 'react'
import Photo from './Photo'
import Video from './Video'

// eslint-disable-next-line react/display-name
export default (props) => (props.type === 'photo' ? <Photo {...props} /> : <Video {...props} />)
